import { create } from "zustand";
import type { PlantContract } from "../types";

interface PlantContractState {
	modalOpen: boolean;
	editingItem: PlantContract | null;
	defaultOrganizationId: string | null;
}

interface PlantContractActions {
	openCreateModal: (organizationId?: string) => void;
	openEditModal: (item: PlantContract) => void;
	closeModal: () => void;
}

type PlantContractStore = PlantContractState & PlantContractActions;

export const usePlantContractStore = create<PlantContractStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultOrganizationId: null,

	openCreateModal: (organizationId) => {
		set({ modalOpen: true, editingItem: null, defaultOrganizationId: organizationId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultOrganizationId: null });
	},
}));
